/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, interval: NonNullable<unknown> }} Recurringsummary1Inputs */

const en_recurringsummary1 = /** @type {(inputs: Recurringsummary1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This will create ${i?.count} dates, each ${i?.interval} apart.`)
};

const de_recurringsummary1 = /** @type {(inputs: Recurringsummary1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dies erstellt ${i?.count} Termine im Abstand von ${i?.interval}.`)
};

/**
* | output |
* | --- |
* | "This will create {count} dates, each {interval} apart." |
*
* @param {Recurringsummary1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringsummary1 = /** @type {((inputs: Recurringsummary1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringsummary1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringsummary1(inputs)
	return de_recurringsummary1(inputs)
});
export { recurringsummary1 as "recurringSummary" }